import { render, staticRenderFns } from "./BundleProducts.vue?vue&type=template&id=eaac380a&"
import script from "./BundleProducts.vue?vue&type=script&lang=js&"
export * from "./BundleProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports